var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08301 7.79167V12.0417M9.91634 7.79167V12.0417M2.83301 4.95833H14.1663M13.458 4.95833L12.8439 13.5589C12.8184 13.9163 12.6585 14.2508 12.3963 14.495C12.1341 14.7392 11.7891 14.875 11.4308 14.875H5.56859C5.21027 14.875 4.86526 14.7392 4.60305 14.495C4.34084 14.2508 4.18091 13.9163 4.15547 13.5589L3.54134 4.95833H13.458ZM10.6247 4.95833V2.83333C10.6247 2.64547 10.55 2.4653 10.4172 2.33247C10.2844 2.19963 10.1042 2.125 9.91634 2.125H7.08301C6.89515 2.125 6.71498 2.19963 6.58214 2.33247C6.4493 2.4653 6.37467 2.64547 6.37467 2.83333V4.95833H10.6247Z",
    stroke: "#3C3C43",
    strokeOpacity: 0.6,
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e0ea1e2eb722191c8658cdc1be658ca5.svg";
export { ForwardRef as ReactComponent };